export class ListData {
  canAdd!: boolean;
  pageIndex!: number;
  totalCount!: number;
  pageSize!: number;
  pageData!: {
    canDelete: boolean
    canEdit: boolean
    canEditStatus: boolean
    id: string
    title: string
    icon: string
    branches: branch[]
    end: string
    start: string
    timeStart: string
    timeEnd: string
    reservationsCount: number
  }[];
}

export class Record {
  id!: any
  restaurantID!: any
  icon!: string
  isSeveralDays!: boolean;
  branches!: branch[]
  endDate!: date
  startDate!: date
  startTime!: string
  endTime!: string
  title_EN!: string
  title_AR!: string
  reservationTimeSlotFrom!: date
  reservationTimeSlotTo!: date
  slots!: slot[]
  note!: string
  eventSlots!: []
}

export class slot {
  id!: number
  timefrom!: string
  isActive!: boolean
  value!: string
}

export class date {
  day!: number;
  month!: number;
  year!: number;
  isHijri!: boolean;
  gregorianDate!: string;
  gregorian!: date;
}

export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
  status!: number
}

export class branch {
  id!: number
  title!: string
}

export enum eventType {
  UpcomingAndOngoing = 1,
  Past = 0
}
